import { SUPPORTED_CURRENCIES } from './types';
import { formatNumber } from './utils';

interface Props {
  currencyCode: string;
  onChange: (code: string) => void;
  exchangeRate: number;
  isLive: boolean;
  isLoading: boolean;
}

const REGIONS = ['Global', 'East Africa', 'West Africa', 'Central Africa', 'Southern Africa'];

export function CurrencySelector({ currencyCode, onChange, exchangeRate, isLive, isLoading }: Props) {
  return (
    <div className="inline-flex items-center gap-1.5">
      {isLoading ? (
        <span className="inline-flex items-center gap-1 text-[10px] text-amber-600">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse" />
          loading
        </span>
      ) : isLive ? (
        <span className="inline-flex items-center gap-1 text-[10px] text-green-600">
          <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
          live
        </span>
      ) : (
        <span className="inline-flex items-center gap-1 text-[10px] text-amber-600">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-400" />
          offline
        </span>
      )}
      <span className="text-[10px] text-spi-slate whitespace-nowrap">
        {formatNumber(exchangeRate, 2)} {currencyCode} = 1 USD
      </span>
      <select
        id="currency-select"
        value={currencyCode}
        onChange={(e) => onChange(e.target.value)}
        className="text-[11px] border border-gray-200 rounded-md px-1.5 py-0.5 bg-white text-spi-charcoal focus:ring-1 focus:ring-spi-green/30 focus:border-spi-green outline-none cursor-pointer"
      >
        {REGIONS.map((region) => (
          <optgroup key={region} label={region}>
            {SUPPORTED_CURRENCIES.filter((c) => c.region === region).map((c) => (
              <option key={c.code} value={c.code}>
                {c.code}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
}
